<template>
  <mobile-multiselect
    v-on="$listeners"
    v-bind="$attrs"
  />
</template>

<script>
import MobileMultiselect from '@/components/mobile-multiselect/mobile-multiselect.vue';

export default {
  components: {
    MobileMultiselect
  }
}
</script>